import { Component, OnInit, OnDestroy, ViewChild, ElementRef, NgZone, Inject, ChangeDetectorRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/services/http/http.service';
import { BasePageComponent } from '../../base-page/base-page.component';
import { IAppState } from 'src/app/interfaces/app-state';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Subject } from 'rxjs';
import { IPageData } from 'src/app/interfaces/page-data';
import { Spinkit } from 'ng-http-loader';
import * as PageActions from '../../../store/actions/page.actions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import swal from 'sweetalert2'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-sharefriends',
  templateUrl: './sharefriends.component.html',
  styleUrls: ['./sharefriends.component.scss']
})
export class SharefriendsComponent extends BasePageComponent implements OnInit, OnDestroy {
  pageData: IPageData;
  public spinkit = Spinkit;
  restoID
  ids
  UserCondition
  token
  tableids
  dishId
  allreviewData
  errorMessage
  referalcode;
  allergenreview = []
  Baselinkshare


  myForm!: FormGroup;
  city_value: any;
  country_value: any;
  city_final: any;
  public latitude: number;
  restoCondition
  public longitude: number;
  @ViewChild('city', { static: false }) public searchElementRef!: ElementRef;

  constructor(store: Store<IAppState>,
    public httpSv: HttpService,
     private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    public dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
   
    super(store, httpSv);

    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: '',
          route: 'sharefriends'
        }
      ]
    };
    this.createForm();
  }
  lat
  lng
  formattedAddress
  ngOnInit() {
    this.token = sessionStorage.getItem('access_token');
    this.route.queryParams.subscribe(params => {
        this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
      });
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["geocode"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.formattedAddress = place.formatted_address;
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.lat = sessionStorage.setItem('lat',JSON.stringify(this.latitude));
          this.lng = sessionStorage.setItem('lng',JSON.stringify(this.longitude));
          sessionStorage.setItem('userLocation',this.formattedAddress);
          sessionStorage.setItem('visitorOrigin',this.formattedAddress)
          if(this.UserCondition) {
            this.restoConditions = "1";
            this.router.navigate(['/horizontal/aggregator'])
          }
         
        });
      });
    });

    // this.restoID = sessionStorage.getItem("restoId")
    // this.token = sessionStorage.getItem('access_token')
    // this.ids = sessionStorage.getItem('restoIds')
    // this.tableids = sessionStorage.getItem('tableIds')
    // this.dishId = sessionStorage.getItem('DishId')
    // this.route.queryParams.subscribe(params => {
    //   this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    // });
    // this.httpSv.shareCodeGet().subscribe(res => {
    //   if (res['status'] == true) {
    //     this.referalcode = btoa(res['result'].data);
    //     this.Baselinkshare = environment.sharelinkUrldecode + this.referalcode
    //   }
    // })
    // if (this.UserCondition) {
    //   this.getAllergensReview();

    //   this.shareCodeGet();

    // }
    // else {
    //   this.guestgetAllergensReview();
    // }
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
  }

  triggerChangeDetection() {
    if (!this.destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  createForm() {
    this.myForm = this.fb.group({
      city: ['', Validators.required],
    });
  }

  clearValue() {
    this.myForm.reset();
  }

  showFilteredResto: boolean = false
  modelChanged(e, somename) {
    if (e.length >= 1) {
      this.showFilteredResto = true;
    } else {
      this.showFilteredResto = false;
    }
  }

  restoConditions
  gotoRestoPage() {
    this.restoConditions = "1";
    this.router.navigate(['/horizontal/aggregator'])
  }
  private destroyed = false;
  ngOnDestroy() {
    this.destroyed = true;
    this.store.dispatch(new PageActions.Reset());
  }
  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        }
      }
    )
  }

  enableCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;

          sessionStorage.setItem('lat', this.lat);
          sessionStorage.setItem('lng', this.lng);
        }
        this.gotoRestoPage();
      },
        (error: PositionError) => {
          const dialogRef = this.dialog.open(UserCheckPermission, {
            width: "321px",
            height: "163px"
          });
        });
    } else {
      swal.fire("Geolocation is not supported by this browser.");
    }
  }


  // guestgetAllergensReview() {
  //   this.httpSv.guestgetAllergensReview(this.restoID, this.dishId).subscribe(
  //     response => {
  //       this.allergenreview = response['result'].data
  //       if (response['status'] == true) {
  //         this.allreviewData = response['result']
  //       }
  //     }, (err: HttpErrorResponse) => {
  //       this.errorMessage = err.error.message
  //       if (err.status == 401) {
  //         this.logout();
  //       }
  //       else if (err.status == 500) {
  //         this.logout();
  //       }
  //     }
  //   )
  // }

  // getAllergensReview() {
  //   this.httpSv.getAllergensReview(this.restoID, this.dishId).subscribe(
  //     response => {
  //       this.allergenreview = response['result'].data
  //       if (response['status'] == true) {
  //         this.allreviewData = response['result']
  //       }
  //     }, (err: HttpErrorResponse) => {
  //       this.errorMessage = err.error.message
  //       if (err.status == 401) {
  //         this.logout();
  //       }
  //       else if (err.status == 500) {
  //         this.logout();
  //       }
  //     }
  //   )
  // }
  // shareCodeGet() {
  //   this.httpSv.shareCodeGet().subscribe(res => {
  //     if (res['status'] == true) {
  //       this.referalcode = btoa(res['result'].data)
  //     }
  //   })
  // }
  // onclickFb() {
  //   window.open(environment.sharelinkUrlFb + this.referalcode);

  // }
  // onclickwhatapp() {
  //   // let Baselink = environment.sharelinkUrlwhatapp + this.referalcode 
  //   // window.location.href = Baselink
  //   window.open(environment.sharelinkUrlwhatapp + this.referalcode);
  // }
  // onclickTwitter() {
  //   // let Baselink = environment.sharelinkUrltwitter + this.referalcode 
  //   // window.location.href = Baselink
  //   window.open(environment.sharelinkUrltwitter + this.referalcode);

  // }



}
@Component({
  selector: 'user-check-permission',
  templateUrl: 'user-check-permission.html',
})
export class UserCheckPermission implements OnInit {
  token
  constructor(
    public dialogRef: MatDialogRef<UserCheckPermission>,
    @Inject(MAT_DIALOG_DATA) public data,
    private _bottomSheet: MatBottomSheet,
    private router: Router
  ) { }
  ngOnInit(): void {

  }

  imsure(): void {
    this.dialogRef.close();
    // this.router.navigate(['/public/resto'])
  }

  retry() {
    this.dialogRef.close();
  }
}





